import React from 'react';
import { ChevronRight, Newspaper } from 'lucide-react';
import { Button } from './ui/button';

const NewsBlog = ({ news = [], loading = false }) => {
  if (loading || news.length === 0) return null;

  return (
    <section className="py-12 px-4" data-testid="news-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#F59E0B]/20 rounded-xl flex items-center justify-center">
              <Newspaper className="w-5 h-5 text-[#F59E0B]" />
            </div>
            <div>
              <h2 className="text-[#F8FAFC] font-bold text-xl font-heading">Box Office Blog</h2>
              <p className="text-[#64748B] text-sm">Latest industry news and analysis</p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {news.slice(0, 6).map((item) => (
            <div key={item.id} className="flex gap-4 p-4 bg-[#121826] rounded-2xl border border-[#1E293B] hover:border-[#F59E0B]/50 hover:shadow-[0_0_20px_rgba(245,158,11,0.1)] transition-all duration-300 group">
              <div className="w-20 h-20 bg-[#1E293B] rounded-xl overflow-hidden flex-shrink-0 flex items-center justify-center">
                {item.image_url ? (
                  <img src={item.image_url} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                ) : (
                  <Newspaper className="w-8 h-8 text-[#F59E0B]/30" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-[#F8FAFC] font-semibold text-sm line-clamp-2 mb-1 group-hover:text-[#F59E0B] transition-colors">{item.title}</h4>
                <p className="text-[#64748B] text-xs line-clamp-2 mb-2">{item.excerpt}</p>
                <span className="text-[#64748B] text-xs">{item.source || 'Bollywood Sensex'}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsBlog;
